<script type="text/ecmascript-6">
    export default {
        props: {
            'product': Object,
            'anchorPrefix': String,
        },

        data() {
            return {
                variants: this.product.groupedVariantsByColor,
            }
        },

        methods: {
            jump: function (anchorName) {
                let searchbarHeight = 61;
                $('html, body').animate({ scrollTop: ($('#'+anchorName).offset().top - searchbarHeight)}, 'slow');
            },
        }
    }
</script>

<template>
    <div>
        <h4>Übersicht</h4>
        <ul class="unstyled">
            <template v-for="groupedVariants in variants">
                <template v-for="(variant, key) in groupedVariants">
                    <li>
                        <span v-if="key === 0">
                            <a @click="jump(anchorPrefix+'-'+variant.color.articleNr)">
                                Farbe
                                <span v-text="variant.color.name"></span>
                                (<span v-text="variant.color.articleNr"></span>)
                            </a>
                        </span>
                        <ul>
                            <li>
                                <a @click="jump(anchorPrefix+'-'+variant.size.articleNr)">
                                    Größe
                                    <span v-text="variant.size.size_id"></span>
                                    (<span v-text="variant.size.gtin"></span>)
                                </a>
                            </li>
                        </ul>
                    </li>
                </template>
            </template>
        </ul>
        <hr/>
    </div>
</template>